import React, { createContext } from 'react';

export interface Settings {
    persona?: number;
    location?: string;
    showMore?: boolean;
    useAlt?: boolean;
}

export const SettingsContext = createContext<Settings>({
    persona: 0,
    location: 'San Francisco',
    showMore: true,
    useAlt: false,
});

export const useSettings = () => {
    const context = React.useContext(SettingsContext);
    if (context === undefined) {
        throw new Error('useSettings must be used within a SettingsProvider');
    }
    return context;
};

interface SettingsProviderProps {
    children: React.ReactNode;
    initialSettings?: Settings;
}

export const SettingsProvider = ({ children, initialSettings }: SettingsProviderProps) => {
    const [settings] = React.useState<Settings>(
        initialSettings || {
            persona: 0,
            location: 'San Francisco',
            showMore: true,
            useAlt: false,
        },
    );

    return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
};
